// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugTwoToneSvg from "@ant-design/icons-svg/es/asn/BugTwoTone";
import AntdIcon from '../components/AntdIcon';

var BugTwoTone = function BugTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BugTwoToneSvg
  }));
};

BugTwoTone.displayName = 'BugTwoTone';
export default React.forwardRef(BugTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BugTwoTone.js
// module id = 687
// module chunks = 0